type SerializableItem = string | number | undefined;
/**
 * Serialize a query object and prepend any additional parameters.
 * Will handle encoding of the query object.
 */
export function serializeQueryString(
  // Query object to be serialzed
  queryObject: Record<string, SerializableItem | SerializableItem[]>
): string {
  const serializedQuery = Object.entries(queryObject)
    .map(([key, value]) => {
      if (value === undefined) {
        return undefined;
      }

      const encodedValue = Array.isArray(value)
        ? encodeURIComponent(
            value
              .filter((v): v is Exclude<typeof v, undefined> => v !== undefined)
              .join(";")
          )
        : encodeURIComponent(value);

      return `${encodeURIComponent(key)}=${encodedValue}`;
    })
    .filter(Boolean)
    .join("&");

  return serializedQuery;
}
